// Access token lives in memory only — never persisted to localStorage.
// The refresh token is stored in an httpOnly cookie managed by the server.
// User profile data (non-sensitive) can still be cached in localStorage
// for display on page reload before the silent refresh completes.

export const CANDIDATE_USER_KEY = 'candidate_user';
const REFRESH_TOKEN_KEY = 'candidate_rt';
const LEGACY_REFRESH_TOKEN_KEY = 'rt';

type UnauthorizedHandler = () => void | Promise<void>;

let onUnauthorized: UnauthorizedHandler | null = null;
let _accessToken: string | null = null;

export function registerUnauthorizedHandler(handler: UnauthorizedHandler | null) {
  onUnauthorized = handler;
}

export async function triggerUnauthorized() {
  clearCandidateSession();
  if (onUnauthorized) await onUnauthorized();
}

export function getCandidateAccessToken(): string | null {
  return _accessToken;
}

export function getCandidateRefreshToken(): string | null {
  if (!import.meta.env.DEV) return null;
  return (
    sessionStorage.getItem(REFRESH_TOKEN_KEY) ??
    sessionStorage.getItem(LEGACY_REFRESH_TOKEN_KEY)
  );
}

export function setCandidateSession(tokenPair: { accessToken: string; refreshToken?: string; expiresIn?: number }) {
  _accessToken = tokenPair.accessToken;
  clearStoredRefreshTokens();
  if (import.meta.env.DEV && tokenPair.refreshToken) {
    sessionStorage.setItem(REFRESH_TOKEN_KEY, tokenPair.refreshToken);
  }
}

export function clearStoredRefreshTokens() {
  sessionStorage.removeItem(REFRESH_TOKEN_KEY);
  sessionStorage.removeItem(LEGACY_REFRESH_TOKEN_KEY);
}

export function clearCandidateSession() {
  _accessToken = null;
  clearStoredRefreshTokens();
  localStorage.removeItem(CANDIDATE_USER_KEY);
}
